import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;
const creatingBioLink = (createdBioLinkData) => {
  // router.post("/createLink/:userid/:token", DashboardController.createLink);
  // token and id  getting from registered user
  const tag = {
    tag: 'main',
  }
  const registeredUserID = createdBioLinkData?.registeredUserID
  const path = `/api/user/createLink/${registeredUserID}`
  const url = baseUrl + path
  const response = axios.post(url, tag)
  // if (response) {
  //   localStorage.removeItem('user')
  // }
  return response.data
}
const bioLinkCreationService = {
  creatingBioLink,
}

export default bioLinkCreationService
